import type { StoredGame } from "./types";

export const GUYMAN_SLUG = "survivor-150-guyman-island";
export const GUYMAN_SEED_EDIT_TOKEN = "guyman-island-edit";

export const guymanGame: StoredGame = {
  id: "game_guyman_survivor_150",
  slug: GUYMAN_SLUG,
  title: "Survivor 150: Guyman Island",
  theme: "Survivor birthday Jeopardy",
  visibility: "unlisted",
  createdAt: "2026-06-15T00:00:00.000Z",
  updatedAt: "2026-06-15T00:00:00.000Z",
  game: {
    title: "Survivor 150",
    eyebrow: "Birthday Tribal Council",
    subtitle: "Guyman Island Jeopardy",
    theme: "Survivor 150: Guyman Island",
    teamNames: ["Team Torch", "Team Tide"],
    boardMinutes: 18,
    sourceNote: "Clues mined from Charlotte and Douglas life story PDFs.",
    categories: [
      {
        category: "Childhood Cache",
        clues: [
          {
            value: 100,
            clue: "Charlotte's brother often made toys for them, including cardboard-box houses and wooden hydroplanes. Which brother was it?",
            answer: "Who is Duncan?",
            source: "Charlotte: favorite toys as a child."
          },
          {
            value: 200,
            clue: "Doug's favorite childhood book centered on effort and growth mindset, with a little engine repeating this phrase.",
            answer: "What is 'I think I can'?",
            source: "Douglas: favorite children's stories."
          },
          {
            value: 300,
            clue: "This beloved doll traveled with Charlotte through Europe, the U.S., Canada, and Mexico, then needed repairs from Grandmother Catherine.",
            answer: "Who is Raggedy Ann?",
            source: "Charlotte: favorite toys as a child."
          },
          {
            value: 400,
            clue: "Doug's favorite childhood toy was this smoke-making, whistle-blowing railroad set.",
            answer: "What is a Lionel electric train set?",
            source: "Douglas: favorite toys as a child."
          }
        ]
      },
      {
        category: "First Challenges",
        clues: [
          {
            value: 100,
            clue: "In college, Charlotte was promoted from Space Needle lobby girl to this upward-moving role.",
            answer: "What is elevator operator?",
            source: "Charlotte: work during college."
          },
          {
            value: 200,
            clue: "Doug's first paid job outside the home paid this hourly wage.",
            answer: "What is $1.25 per hour?",
            source: "Douglas: first job."
          },
          {
            value: 300,
            clue: "Will introduced Charlotte to this happiness book while taking a class at Stanford; she later took a course by the same name.",
            answer: "What is Awakening Joy?",
            source: "Charlotte: books that made a difference."
          },
          {
            value: 400,
            clue: "Charlotte said she felt vicarious joy each time one of the Guyman kids learned this skill, got their first new one, and had their first big outing alone on it.",
            answer: "What is riding a bike?",
            source: "Charlotte: having children."
          }
        ]
      },
      {
        category: "Island Trials",
        clues: [
          {
            value: 100,
            clue: "Doug's family explored Puget Sound and the San Juans in a 28-foot power boat with this double name.",
            answer: "What is My-My?",
            source: "Douglas: childhood vacations."
          },
          {
            value: 200,
            clue: "Doug's family bought a waterfront cottage on this passage, just southwest of the Bainbridge bridge.",
            answer: "What is Agate Passage?",
            source: "Douglas: childhood vacations."
          },
          {
            value: 300,
            clue: "From ages 13 to 15, Doug collected eggs, milked cows, and drove a tractor on this island farm.",
            answer: "What is Lopez Island?",
            source: "Douglas: childhood vacations."
          },
          {
            value: 400,
            clue: "On the family trip home from Sun Valley, this child kept a log of the 21 things that went wrong.",
            answer: "Who is Elizabeth?",
            source: "Douglas: missed flights."
          }
        ]
      },
      {
        category: "Alliance & Family",
        clues: [
          {
            value: 100,
            clue: "Charlotte first kept hearing 'you'll have to meet Doug Guyman' when she started at this company.",
            answer: "What is Hewlett Packard?",
            source: "Charlotte: how she met Doug."
          },
          {
            value: 200,
            clue: "For Doug's 50th birthday, the family sailed to this island anyway, even though Charlotte was seven months pregnant.",
            answer: "What is Sucia?",
            source: "Douglas: memorable birthdays."
          },
          {
            value: 300,
            clue: "Charlotte spent her 32nd birthday in the hospital staring at this newborn.",
            answer: "Who is Elizabeth?",
            source: "Charlotte: memorable birthdays."
          },
          {
            value: 400,
            clue: "On the rainy Memorial Day sail that helped shift Doug and Charlotte toward romance, Charlotte brought groceries, full rain gear, and this homemade dinner.",
            answer: "What is pasta sauce?",
            source: "Charlotte: how she met Doug."
          }
        ]
      },
      {
        category: "Campfire Lore",
        clues: [
          {
            value: 100,
            clue: "Because of her love for lattes, some friends gave Charlotte this coffee-flavored nickname.",
            answer: "What is CharLatte?",
            source: "Charlotte: favorite drinks."
          },
          {
            value: 200,
            clue: "Doug listed this workplace comedy among his adult TV favorites.",
            answer: "What is The Office?",
            source: "Douglas: favorite TV shows."
          },
          {
            value: 300,
            clue: "For April Fool's Day, Charlotte made fake cupcakes out of this dinner food, with colored mashed potatoes as frosting.",
            answer: "What is meatloaf?",
            source: "Charlotte: pranks."
          },
          {
            value: 400,
            clue: "Doug's dad jokingly gave this name to their 18-foot wooden outboard boat because the wood came from Foster Lumberyard.",
            answer: "What is Fostercraft?",
            source: "Douglas: childhood vacations."
          }
        ]
      }
    ],
    final: {
      clue: "Charlotte called this \"the greatest gift of my life\" and said it has been so much better than she ever imagined.",
      answer: "What is having children?",
      source: "Charlotte: having children."
    }
  }
};
